import React from "react";
import classNames from "classnames";
import { ResourcesIcon } from "./resourcesIcon";
import { ExpenseIcon } from "./expenseIcon";
import styles from "./styles.scss";

import { Props } from "./types";
import { AllocationUnit } from "@common/allocationUnit";

function toFixed(nbr: number) {
  return typeof nbr !== "undefined"
    ? Math.round(nbr) === nbr
      ? nbr
      : nbr.toFixed(2)
    : "";
}

function TableRow({ synthesis, rowType, editBudget }: Props) {
  const [value, setValue] = React.useState(0);
  const isResources = rowType === "Resources";
  const Icon = isResources ? ResourcesIcon : ExpenseIcon;
  const budget = isResources
    ? synthesis.allocatedResourcesBudget
    : synthesis.allocatedExpensesBudget;
  const values = isResources
    ? [
        {
          value: synthesis.plannedValueAtDateOfResources,
          unit: "€",
        },
        {
          value: synthesis.realCostAtDateOfResources,
          unit: "€",
        },
        {
          value: synthesis.acquiredValueOfResources,
          unit: "€",
        },
        {
          value: synthesis.plannedValueOfResources,
          unit: "€",
        },
        {
          value: synthesis.realCostOfResources,
          unit: "€",
        },
        {
          value: synthesis.acquiredValueOfResources,
          unit: "€",
        },
        {
          value: synthesis.totalSumOfTimeAllocatedOnTheProject,
          unit: <AllocationUnit />,
        },
        {
          value: synthesis.totalOfTimesSpentInProject,
          unit: <AllocationUnit />,
        },
        {
          value: synthesis.totalOfRemainingTimeInProject,
          unit: <AllocationUnit />,
        },
      ]
    : [
        {
          value: synthesis.plannedValueAtDateOfExpenses,
          unit: "€",
        },
        {
          value: synthesis.realCostAtDateOfExpenses,
          unit: "€",
        },
        {
          value: synthesis.acquiredValueOfExpenses,
          unit: "€",
        },
        {
          value: synthesis.plannedValueOfExpenses,
          unit: "€",
        },
        {
          value: synthesis.realCostOfExpenses,
          unit: "€",
        },
        {
          value: synthesis.acquiredValueOfExpenses,
          unit: "€",
        },
      ];

  React.useEffect(() => {
    setValue(
      parseFloat(
        isResources
          ? synthesis.allocatedResourcesBudget
          : synthesis.allocatedExpensesBudget,
      ),
    );
  }, [synthesis.allocatedExpensesBudget, synthesis.allocatedResourcesBudget]);
  return (
    <div className={styles.tableBody}>
      <div className={styles.smallLabel}>
        <Icon className={styles.icon} />
        <form
          className={styles.group}
          onSubmit={(e) => {
            e.preventDefault();
            editBudget(value);
          }}
        >
          <input
            type="number"
            value={value}
            className={styles.input}
            step="0.5"
            onChange={({ target }) =>
              setValue(!!target.value ? parseFloat(target.value) : 0)
            }
            onBlur={() => value !== parseFloat(budget) && editBudget(value)}
          />
        </form>
        <p className={styles.value}>€</p>
      </div>
      {values.map((item, index) => (
        <div
          key={`value-${index}`}
          className={classNames({
            [styles.warning]: typeof item.value === "number" && item.value < 0,
          })}
        >
          {item.unit === "€"
            ? typeof item.value === "number" && item.value >= 1000
              ? `${(item.value / 1000).toFixed(2)}k`
              : toFixed(Number(item.value))
            : toFixed(Number(item.value))}{" "}
          {item.unit}
        </div>
      ))}
      {!isResources && <div className={styles.fillerCell}></div>}
    </div>
  );
}

export { TableRow };
